import { createContext } from 'react';

export interface EventInfo {
  activeError: string
  updateError: any
}

export const EventInfoContext = createContext<EventInfo>({
  activeError: null,
  updateError: () => {},
});
